import { render, staticRenderFns } from "./RationsTable.vue?vue&type=template&id=44f4c14f&scoped=true&lang=pug&"
import script from "./RationsTable.vue?vue&type=script&lang=js&"
export * from "./RationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RationsTable.vue?vue&type=style&index=0&id=44f4c14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4c14f",
  null
  
)

export default component.exports